"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ComponentResolver =
/*#__PURE__*/
function () {
  function ComponentResolver() {
    _classCallCheck(this, ComponentResolver);

    this.component = null;
  }

  _createClass(ComponentResolver, [{
    key: "setComponentFromRenderer",
    value: function setComponentFromRenderer(renderer) {
      this.setComponent(renderer.getComponent(), renderer.getComponentProps());
    }
  }, {
    key: "setComponent",
    value: function setComponent(component, componentProps) {
      this.component = function (props) {
        return _react.default.createElement(component, _objectSpread({}, componentProps, props));
      };
    }
  }, {
    key: "getComponent",
    value: function getComponent() {
      return this.component;
    }
  }]);

  return ComponentResolver;
}();

exports.default = ComponentResolver;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9saWIvQ29tcG9uZW50UmVzb2x2ZXIuanMiXSwibmFtZXMiOlsiQ29tcG9uZW50UmVzb2x2ZXIiLCJjb21wb25lbnQiLCJyZW5kZXJlciIsInNldENvbXBvbmVudCIsImdldENvbXBvbmVudCIsImdldENvbXBvbmVudFByb3BzIiwiY29tcG9uZW50UHJvcHMiLCJwcm9wcyIsIlJlYWN0IiwiY3JlYXRlRWxlbWVudCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7Ozs7Ozs7Ozs7OztJQUVxQkEsaUI7OztBQUNuQiwrQkFBYztBQUFBOztBQUNaLFNBQUtDLFNBQUwsR0FBaUIsSUFBakI7QUFDRDs7Ozs2Q0FFd0JDLFEsRUFBVTtBQUNqQyxXQUFLQyxZQUFMLENBQWtCRCxRQUFRLENBQUNFLFlBQVQsRUFBbEIsRUFBMkNGLFFBQVEsQ0FBQ0csaUJBQVQsRUFBM0M7QUFDRDs7O2lDQUVZSixTLEVBQVdLLGMsRUFBZ0I7QUFDdEMsV0FBS0wsU0FBTCxHQUFpQixVQUFDTSxLQUFELEVBQVc7QUFDMUIsZUFBT0MsZUFBTUMsYUFBTixDQUFvQlIsU0FBcEIsb0JBQ0ZLLGNBREUsRUFFRkMsS0FGRSxFQUFQO0FBSUQsT0FMRDtBQU1EOzs7bUNBRWM7QUFDYixhQUFPLEtBQUtOLFNBQVo7QUFDRCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgQ29tcG9uZW50UmVzb2x2ZXIge1xuICBjb25zdHJ1Y3RvcigpIHtcbiAgICB0aGlzLmNvbXBvbmVudCA9IG51bGw7XG4gIH1cblxuICBzZXRDb21wb25lbnRGcm9tUmVuZGVyZXIocmVuZGVyZXIpIHtcbiAgICB0aGlzLnNldENvbXBvbmVudChyZW5kZXJlci5nZXRDb21wb25lbnQoKSwgcmVuZGVyZXIuZ2V0Q29tcG9uZW50UHJvcHMoKSk7XG4gIH1cblxuICBzZXRDb21wb25lbnQoY29tcG9uZW50LCBjb21wb25lbnRQcm9wcykge1xuICAgIHRoaXMuY29tcG9uZW50ID0gKHByb3BzKSA9PiB7XG4gICAgICByZXR1cm4gUmVhY3QuY3JlYXRlRWxlbWVudChjb21wb25lbnQsIHtcbiAgICAgICAgLi4uY29tcG9uZW50UHJvcHMsXG4gICAgICAgIC4uLnByb3BzXG4gICAgICB9KTtcbiAgICB9O1xuICB9XG5cbiAgZ2V0Q29tcG9uZW50KCkge1xuICAgIHJldHVybiB0aGlzLmNvbXBvbmVudDtcbiAgfVxufVxuIl19


//////////////////
// WEBPACK FOOTER
// ./node_modules/async-react-router/lib/ComponentResolver.js
// module id = 248
// module chunks = 0